export default __webpack_public_path__ + "static/media/counting_stars.d1b3ce73.svg";